export const CMS_API_URL =
  process.env.GATSBY_LEADCMS_API_URL ?? "https://cms.core.all3.com";
